"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverflowButton = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _encoreFoundation = require("@spotify-internal/encore-foundation");
var _index = require("../../../components/ButtonPrimary/index.js");
var _index2 = require("../../../components/Icon/icons/IconChevronLeft/index.js");
var _index3 = require("../../../components/Icon/icons/IconChevronRight/index.js");
var _styledComponents = _interopRequireWildcard(require("../../../styled-components.js"));
var _layoutTheme = require("../../layout-theme.js");
var _excluded = ["position", "show"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ButtonPrimaryContainer = _styledComponents["default"].div.withConfig({
  displayName: "OverflowButton__ButtonPrimaryContainer",
  componentId: "sc-e0k2al-0"
})(["", ""], function (_ref) {
  var $position = _ref.$position,
    $show = _ref.$show;
  return (0, _styledComponents.css)(["position:absolute;display:flex;inset-block:0;z-index:1;opacity:1;transition:opacity 0.3s;place-content:center center;min-inline-size:", ";pointer-events:none;> button{pointer-events:auto;}", ";", " @media (max-width:", "){opacity:0;}"], (0, _layoutTheme.cssControlSize)('base', '48px'), $position === 'start' ? (0, _styledComponents.css)(["inset-inline-start:0;margin-inline-end:calc(-1 * ", ");"], (0, _layoutTheme.cssControlSize)('base', '48px')) : (0, _styledComponents.css)(["inset-inline-end:0;margin-inline-start:calc(-1 * ", ");"], (0, _layoutTheme.cssControlSize)('base', '48px')), !$show && (0, _styledComponents.css)(["opacity:0;> button{pointer-events:none;}"]), _encoreFoundation.screenXsMax);
});

/**
 * A11y note:
 * OverflowButton is intentionally not keyboard accessible (via aria-hidden and tabindex=-1)
 * as they are only useful for visual / mouse users.
 */
var OverflowButton = exports.OverflowButton = function OverflowButton(_ref2) {
  var position = _ref2.position,
    show = _ref2.show,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  return /*#__PURE__*/_react["default"].createElement(ButtonPrimaryContainer, {
    $position: position,
    $show: show
  }, /*#__PURE__*/_react["default"].createElement(_index.ButtonPrimary, Object.assign({
    "aria-hidden": "true",
    tabIndex: -1,
    iconOnly: position === 'start' ? _index2.IconChevronLeft : _index3.IconChevronRight,
    size: "small",
    colorSet: "overMedia",
    "data-testid": "overflow-button-".concat(position)
  }, props)));
};